// MST1020_R01 BOM 관련 유틸리티 함수 및 상수

import { allowedAccountsArr } from "src/components/common/common";
import { MST3040_R01DetailDto } from "./Dto_MST3040_R01";
import { showWarning } from "src/utils/toast/toastUtil";

// BOM 컬럼 헤더명
export const headerNames_MST3040_R01Detail: Record<string, string> = {
	rowIndex: "",
	coordinateCd: '로케이션',
	coordinateNm: '로케이션명',
	coordinateSeq: '순번',
	xcoordinate: 'X좌표',
	ycoordinate: 'Y좌표',
	orient: '방향',
	topBottom: 'Layer',
	childItemcd: '자품목코드',
	childItemnm: '자품목명',
	itemSpec: '규격',
	locationNm: '보관위치',
	coordinateUsage: '소요량',
	afeederCd: 'a피더코드',
	bfeederCd: 'b피더코드',
	cfeederCd: 'c피더코드',
	remark: '비고',
};

// 원본 데이터 복구 함수
export function restoreOriginalValues(
  valueIndex: number,
  originalData: MST3040_R01DetailDto,
  updateMST3040_R01Detail: (index: number, data: MST3040_R01DetailDto) => void,
  gridRef: any
) {
  setTimeout(() => {
    updateMST3040_R01Detail(valueIndex, {
      ...originalData,
      isModified: originalData.inserted === true ? false : true
    });
    if (gridRef.current?.api) {
      const allRowNodes: any[] = [];
      gridRef.current.api.forEachNode((node: any) => {
        if (node.data && node.data.valueIndex === valueIndex) {
          allRowNodes.push(node);
        }
      });
      if (allRowNodes.length > 0) {
        const targetNode = allRowNodes[0];
        targetNode.setDataValue('childItemcd', originalData.childItemcd);
        targetNode.setDataValue('childItemnm', originalData.childItemnm);
        targetNode.setDataValue('itemSpec', originalData.itemSpec ?? '');
        targetNode.setDataValue('locationCd', originalData.locationCd ?? '');
        targetNode.setDataValue('locationNm', originalData.locationNm ?? '');
      }
    }
  }, 100);
}

// 행 편집 가능 여부
export function isEditableRow(
  params: any,
  originalMST3040_R01DetailList: MST3040_R01DetailDto[],
  deletedMST3040_R01DetailList: (string | number)[]
): boolean {
  if (params.data?.inserted) return true;
  const originalData = originalMST3040_R01DetailList.find(item => item.valueIndex === params.data?.valueIndex);
  if (params.data?.childItemcd && deletedMST3040_R01DetailList.includes(params.data.childItemcd)) return false;
  return true;
}
	
// 품목 계정 검증
export function validateItemAccount(itemAccount: string) {
  return allowedAccountsArr.includes(itemAccount);
}

// 중복 체크
export function isDuplicateChildItemcd(
  list: MST3040_R01DetailDto[],
  itemCd: string,
  valueIndex: number
) {
  return list.filter(item => item.childItemcd === itemCd && item.valueIndex !== valueIndex).length > 0;
}

// 손실율/필요수량 자동 계산 로직은 제거되었습니다.